/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Followers_OnlyInputs */

const en_story_followers_only = /** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Followers only`)
};

const es_story_followers_only = /** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo seguidores`)
};

const fr_story_followers_only = /** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnés uniquement`)
};

const de_story_followers_only = /** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Follower`)
};

const id_story_followers_only = /** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya pengikut`)
};

/** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */
const ja_story_followers_only = en_story_followers_only;

/** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */
const zh_story_followers_only = en_story_followers_only;

/** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */
const ar_story_followers_only = en_story_followers_only;

/** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */
const it_story_followers_only = en_story_followers_only;

/** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */
const ru_story_followers_only = en_story_followers_only;

/** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */
const pt_story_followers_only = en_story_followers_only;

/** @type {(inputs: Story_Followers_OnlyInputs) => LocalizedString} */
const ko_story_followers_only = en_story_followers_only;

/**
* | output |
* | --- |
* | "Followers only" |
*
* @param {Story_Followers_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_followers_only = /** @type {((inputs?: Story_Followers_OnlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Followers_OnlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_followers_only(inputs)
	if (locale === "es") return es_story_followers_only(inputs)
	if (locale === "fr") return fr_story_followers_only(inputs)
	if (locale === "de") return de_story_followers_only(inputs)
	if (locale === "ja") return ja_story_followers_only(inputs)
	if (locale === "zh") return zh_story_followers_only(inputs)
	if (locale === "ar") return ar_story_followers_only(inputs)
	if (locale === "id") return id_story_followers_only(inputs)
	if (locale === "it") return it_story_followers_only(inputs)
	if (locale === "ru") return ru_story_followers_only(inputs)
	if (locale === "pt") return pt_story_followers_only(inputs)
	return ko_story_followers_only(inputs)
});